import OutboundLink from 'components/OutboundLink';

function BisBoilerNumLink({ text, rowData }) {
	const label = text || rowData?.num;
	if (!label) {
		return '-';
	}

	const url = rowData?.uri;
	if (!url) {
		return label;
	}

	return <OutboundLink url={url} text={label} noIcon />;
}

export default BisBoilerNumLink;
